namespace Core {
    angular
        .module('core')
        .directive('callToBookModal', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {
                    show: '=',
                    close: '&'
                },
                templateUrl: 'partials/Home/directivetemplate?type=CallToBookModal',
            };
        });
}
